import { TripDetailsForTripEditFormQuery } from '@website/types/graphqlOperations';
import PostBookingAutomatedMessageForm from './AutomatedMessages/PostBookingAutomatedMessage';
import PreDepartureAutomatedMessage from './AutomatedMessages/PreDepartureAutomatedMessages';

type Props = {
  tripID: string;
  automatedMessage?: string;
  preDepartureAutomatedMessages: TripDetailsForTripEditFormQuery['tripByURL']['automatedMessages'];
};

export default function AutomatedMessageForm({
  tripID,
  automatedMessage,
  preDepartureAutomatedMessages,
}: Props) {
  return (
    <>
      <PostBookingAutomatedMessageForm
        tripID={tripID}
        automatedMessage={automatedMessage}
      />
      <hr />
      <PreDepartureAutomatedMessage
        tripID={tripID}
        automatedMessages={preDepartureAutomatedMessages}
      />
    </>
  );
}
